import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import AppShell from "./app/AppShell";

import Main from "./Main";
import Home from "./pages/Home";
import TermsWrapper from "./Terms";
import PrivacyWrapper from "./Privacy";
import ValidateEmail from "./ValidateEmail";
import ResetPassword from "./ResetPassword";
import PaymentWrapper from "./PaymentVerification";
import Products from "./pages/Products";
import ProductDetails from "./pages/ProductDetails";
import Locations from "./pages/Locations";
import LocationDetails from "./pages/LocationDetails";
import InvoiceGenerator from "./pages/InvoiceGenerator";
import FeedbackGenerator from "./pages/FeedbackGenerator";
import AppDownload from "./pages/AppDownload";
import SkipTheLinePage from "./skipLine";
import ClientLoginPage from "./pages/ClientLoginPage";
import ClientRegisterPage from "./pages/ClientRegisterPage";
import ClientForgotPasswordPage from "./pages/ClientForgotPasswordPage";
import ClientAccountPage from "./pages/ClientAccountPage";
import { ClientPortalProvider } from "./clientPortal/ClientPortalContext";
import { useClientPortalConfig } from "./clientPortal/clientPortalConfig";
import RequireClientPortal from "./clientPortal/RequireClientPortal";
import { APP_BASE_PATH } from "./app/runtimeConfig";

function App() {
  const clientPortalConfig = useClientPortalConfig();

  return (
    <BrowserRouter
      basename={APP_BASE_PATH}
      future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
    >
      <ClientPortalProvider
        configReady={clientPortalConfig.ready}
        enabled={clientPortalConfig.enabled}
        claimEnabled={clientPortalConfig.claimEnabled}
        authenticatedCheckoutEnabled={
          clientPortalConfig.authenticatedCheckoutEnabled
        }
      >
        <Routes>
          {/* ✅ Standalone pages (NO header/footer) */}
          <Route path="/terms" element={<TermsWrapper />} />
          <Route path="/privacy" element={<PrivacyWrapper />} />
          <Route path="/validateEmail" element={<ValidateEmail />} />
          <Route path="/validate-email" element={<ValidateEmail />} />
          <Route path="/resetPassword" element={<ResetPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/paymentVerification" element={<PaymentWrapper />} />
          <Route path="/skipline" element={<SkipTheLinePage />} />
          <Route path="/skipLine" element={<SkipTheLinePage />} />

          {/* ✅ Everything else uses the website shell */}
          <Route
            path="*"
            element={
              <AppShell>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/home" element={<Home />} />

                  <Route path="/products" element={<Products />} />
                  <Route path="/products/:slug" element={<ProductDetails />} />

                  <Route path="/locations" element={<Locations />} />
                  <Route path="/locations/:iref" element={<LocationDetails />} />

                  <Route path="/main" element={<Main />} />
                  <Route path="/accounts" element={<Main />} />
                  <Route path="/app" element={<AppDownload />} />

                  <Route path="/login" element={<ClientLoginPage />} />
                  <Route path="/register" element={<ClientRegisterPage />} />
                  <Route
                    path="/forgot-password"
                    element={<ClientForgotPasswordPage />}
                  />
                  <Route
                    path="/forgotPassword"
                    element={<ClientForgotPasswordPage />}
                  />
                  <Route
                    path="/account"
                    element={
                      <RequireClientPortal>
                        <ClientAccountPage />
                      </RequireClientPortal>
                    }
                  />

                  <Route path="/invoice" element={<InvoiceGenerator />} />
                  <Route path="/feedback" element={<FeedbackGenerator />} />

                  {/* fallback */}
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </AppShell>
            }
          />
        </Routes>
      </ClientPortalProvider>
    </BrowserRouter>
  );
}

export default App;
